<template>
  <div class="table e-table-editable">

    <div class="e-table-editable-container">
      <div class="e-table-editable__fixed-right"
           v-if="hasRightFixedCols && data && data.data && data.data.length > 0"
           :style="{
  'width': `${actionColumnWidth}px`,
  'margin-right': `${marginOnScrollReleased}px`
}"
      >
        <div class="e-table-editable__fixed-right-patch"></div>
        <div class="e-table-editable__header-wrapper">
          <table v-if="attributes" class="e-table-editable__header"
                 :style="{ 'margin-left': `-${tableWidth}px`}"
          >
            <colgroup>
              <col v-for="(attr, name) in fieldsCols"
                   :width="attr.resizedWidth"
              >
              <col :width="actionColumnWidth">
            </colgroup>
            <thead>
            <tr>
              <th v-for="(attr, name) in attributes">
                <template
                  v-if="attr.sort && !tableInOfflineMode"
                >
                  <div
                    class="is-hide sortable text"
                    v-html="$translate(attr.label)"
                  ></div>
                  <div class="is-hide sortable arrows">
                  <span
                    class="up"
                  ></span>
                    <span
                      class="down"
                    ></span>
                  </div>
                </template>
                <template
                  v-else
                >
                  <div
                    class="is-hide"
                    v-html="$translate(attr.label)"
                  ></div>
                </template>
              </th>
              <th class="is-show"><div class="is-show">&nbsp;</div></th>
            </tr>
            </thead>
          </table>
        </div>

        <e-perfect-scrollbar
          :emitTypes="scrollBarEmitTypes"
          @ps-scroll-y="scrollTopHandler($event.event)"
          @ps-scroll-x="scrollTopHandler($event.event)"
          :config="{suppressScrollY: false, suppressScrollX: true}"
          ref="tableFixedPS"
          :updateStreamName="scrollBarUpdateStreamName"
          class="fixed-left-scrollbar"
        >
          <div class="e-table-editable__body-wrapper"
               ref="tableFixed"
               :style="{
               'height': fixedTableRightHeight ? `${fixedTableRightHeight}px` : ``
           }"
          >
            <table v-if="attributes"
                   class="e-table-editable__body"
                   :style="{
          'margin-left': `-${tableWidth}px`
        }"
            >
              <colgroup>
                <col v-for="(attr, name) in fieldsCols"
                     :width="attr.resizedWidth + magicChromePixel"
                >
                <col :width="actionColumnWidth">
              </colgroup>
              <tbody>
              <template v-if="data && data.data">
                <template v-for="(model, rowIndex) in data.data">
                  <tr v-if="isEdit(model)" class="editable">
                    <td
                      v-for="(attr, name) in attributes"
                      :class="{
                     'to-top last': (!fewRows && rowIndex > data.data.length - toTopRowsCount),
                     'is-invalid': getValidationError(model, name)
                    }"
                    >
                      <div v-if="attr.suggestion && attr.suggestion.multiple" :class="'field-'+name">
                        <input type="text" class="is-in-fixed">
                      </div>
                      <div v-else-if="attr.suggestion" :class="'field-'+name">
                        <input type="text" class="is-in-fixed">
                      </div>
                      <div v-else-if="attr.select" :class="'field-'+name">
                        <input type="text" class="is-in-fixed">
                      </div>
                      <div v-else-if="attr.calendar" :class="'field-'+name">
                        <input type="text" class="is-in-fixed">
                      </div>
                      <div v-else :class="'field-'+name">
                        <input type="text" class="is-in-fixed">
                      </div>
                      <span class="invalid error table-invalid">{{getValidationError(model, name)}}</span>
                    </td>
                    <td>
                      <div class="buttons is-show">
                        <template
                          v-if="$scopedSlots['buttons']"
                        >
                          <slot
                            name="buttons"
                            :model="model"
                            :acceptEdit="acceptEdit"
                            :acceptDelete="acceptDelete"
                            :acceptCreate="acceptCreate"
                          ></slot>
                        </template>
                        <template v-else>
                          <button
                            v-if="acceptEdit"
                            @click.prevent="onToggleEditable(model)"
                            class="row-edit"
                            :title="$translate('Редактировать')"
                          ></button>
                          <button
                            v-if="acceptDelete"
                            @click.prevent="deleteRow(model)"
                            class="row-delete"
                            :title="$translate('Удалить')"
                          ></button>
                        </template>
                      </div>
                      <span class="invalid error table-invalid is-show">{{getValidationError(model, 'edit')}}</span>
                    </td>
                  </tr>
                  <tr v-else @dblclick="onToggleEditable(model, (rowIndex))">
                    <td v-for="(attr, name) in attributes">
                      <div v-if="attr.hasOwnProperty('transform')"
                           :class="'field-'+name"
                           v-html="attr.transform(model)"></div>
                      <div v-else
                           v-html="model[name]"
                           :class="'field-'+name"
                      ></div>
                    </td>
                    <td>
                      <div class="buttons is-show">
                        <template
                          v-if="$scopedSlots['buttons']"
                        >
                          <slot
                            name="buttons"
                            :model="model"
                            :acceptEdit="acceptEdit"
                            :acceptDelete="acceptDelete"
                            :acceptCreate="acceptCreate"
                          ></slot>
                        </template>
                        <template v-else>
                          <button
                            v-if="acceptEdit"
                            @click.prevent="onToggleEditable(model)"
                            class="row-edit"
                            :title="$translate('Редактировать')"
                          ></button>
                          <button
                            v-if="acceptDelete"
                            @click.prevent="deleteRow(model)"
                            class="row-delete"
                            :title="$translate('Удалить')"
                          ></button>
                        </template>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr v-if="showSummaryColumns" class="summary bold">
                  <td v-for="(attr, name, index) in attributes">
                    <div v-if="index > 0" :class="'field-'+name">
                      {{getSumOf(name)}}
                    </div>
                    <div v-else>{{$translate('Итого')}}</div>
                  </td>
                  <td class="is-show"></td>
                </tr>
              </template>
              <template v-if="fewRows">
                <tr class="empty-row" :style="{'height': emptyRowHeight}">
                  <td v-for="(attr, name) in attributes">
                    <div></div>
                  </td>
                  <td><div class="is-show"></div></td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </e-perfect-scrollbar>
      </div>

      <!-- real table -->
      <div
        class="e-table-editable__header-wrapper"
        ref="tableHeaderWrapper"
      >
        <table v-if="attributes" class="e-table-editable__header"
               ref="tableHeader"
               :style="{ 'margin-left': `-${scrollLeft}px`}"
        >
          <colgroup>
            <col v-for="(attr, name) in fieldsCols"
                 :width="attr.resizedWidth"
            >
            <col :width="actionColumnWidth">
          </colgroup>
          <thead>
          <tr>
            <th v-for="(attr, name) in attributes">
              <template
                v-if="attr.sort && !tableInOfflineMode"
              >
                <div
                  class="sortable text"
                  v-html="$translate(attr.label)"
                ></div>
                <div class="sortable arrows">
                <span
                  class="up"
                  :class="{'active': sortedFields[attr.sortName || name] && sortedFields[attr.sortName || name] == 'asc'}"
                  @click.prevent.stop="sortByField(attr.sortName || name, 'asc')"
                ></span>
                  <span
                    class="down"
                    :class="{'active': sortedFields[attr.sortName || name] && sortedFields[attr.sortName || name] == 'desc'}"
                    @click.prevent.stop="sortByField(attr.sortName || name, 'desc')"
                  ></span>
                </div>
              </template>
              <template
                v-else
              >
                <div
                  v-html="$translate(attr.label)"
                ></div>
              </template>
            </th>
            <th><div></div></th>
          </tr>
          </thead>
        </table>
      </div>

      <e-perfect-scrollbar
        :emitTypes="scrollBarEmitTypes"
        @ps-scroll-y="scrollLeftHandler($event.event)"
        @ps-scroll-x="scrollLeftHandler($event.event)"
        :config="{suppressScrollY: false, suppressScrollX: false}"
        :updateStreamName="scrollBarUpdateStreamName"
        ref="tablePS"
        class="real-table-scrollbar"
      >
        <!-- 'overflow': bodyWrapperOverflow, -->
        <div class="e-table-editable__body-wrapper"
             :style="{
          'height': fixedTableHeight ? `${fixedTableHeight}px` : ``,
          'margin-top': `-${scrollTop}px`
        }"
             ref="table"
             @scroll="scrollLeftHandler">
          <table v-if="attributes" class="e-table-editable__body">
            <colgroup>
              <col v-for="(attr, name) in fieldsCols"
                   :width="attr.resizedWidth"
              >
              <col :width="actionColumnWidth">
            </colgroup>
            <tbody v-if="data && data.data && data.data.length > 0">
            <template v-for="(model, rowIndex) in data.data">
              <tr v-if="isEdit(model)"
                  ref="rows"
                  :data-id="model.id || model._storeUUID"
                  class="editable">
                <td
                  v-for="(attr, name) in attributes"
                  :data-name="name"
                  :class="{
                  'to-top last': (!fewRows && rowIndex > data.data.length - toTopRowsCount),
                  'is-invalid': getValidationError(model, name)
                }">
                  <slot
                    v-if="$scopedSlots[name]"
                    :name="name"
                    :model="model"
                    :attr="attr"
                  >
                  </slot>
                  <div v-else-if="attr.suggestion && attr.suggestion.multiple" :class="'field-'+name">
                    <e-suggestion-multiselect
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :model="model"
                      :name="attr.suggestion.modelName || name"
                      :suggestionEndpoint="attr.suggestion.suggestionEndpoint"
                      :transformSuggestions="attr.suggestion.transformSuggestions"
                      :placeholder="getPlaceholder(model, attr, name)"
                      @enter="saveRow(model, (rowIndex), false)"
                      @change="onChange($event, model, attr);saveAfterChange(model)"
                      :useInnerSearch="attr.suggestion.useInnerSearch"
                      :minSuggestLen="attr.suggestion.minSuggestLen"
                      :options="attr.suggestion.options"
                      :showTags="attr.suggestion.showTags"
                      :checkBoxOnLeft="attr.suggestion.checkBoxOnLeft"
                    ></e-suggestion-multiselect>
                  </div>
                  <div v-else-if="attr.suggestion" :class="'field-'+name">
                    <e-suggestion
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :model="model"
                      :name="name"
                      :suggestionEndpoint="attr.suggestion.suggestionEndpoint"
                      :transformSuggestions="attr.suggestion.transformSuggestions"
                      :placeholder="getPlaceholder(model, attr, name)"
                      @enter="saveRow(model, (rowIndex), false)"
                      @selectItem="onSelectItem($event, model, attr)"
                      :useInnerSearch="attr.suggestion.useInnerSearch"
                      :minSuggestLen="attr.suggestion.minSuggestLen"
                      :options="attr.suggestion.options"
                      :nameKey="attr.suggestion.nameKey"
                    ></e-suggestion>
                  </div>
                  <div v-else-if="attr.select" :class="'field-'+name">
                    <e-select
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :model="model"
                      :name="name"
                      :tabView="tabView"
                      :placeholder="getListPlaceholder(model, attr, name)"
                      @enter="saveRow(model, (rowIndex), false)"
                      @change="onChangeModelValue(attr, name, model);saveAfterChange(model, (rowIndex))"
                      @blur="saveAfterChange(model)"
                      :options="(attr.select.transformOptions ? attr.select.transformOptions(model) : attr.select.options)"
                      :disablePlaceholderOption="attr.select.disablePlaceholderOption"
                    ></e-select>
                  </div>
                  <div v-else-if="attr.calendar" :class="'field-'+name">
                    <e-calendar
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :name="name"
                      :model="model"
                      :placeholder="getPlaceholder(model, attr, name)"
                      v-model="model[name]"
                      @keyup.enter.prevent="saveRow(model, (rowIndex), false)"
                      @blur="saveAfterChange(model)"
                      tabView="tab2"
                      :valueFormat="attr.calendar.valueFormat"
                      :format="attr.calendar.format"
                    ></e-calendar>
                  </div>
                  <div v-else-if="attr.time" :class="'field-'+name">
                    <e-time
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :name="name"
                      :model="model"
                      :placeholder="getPlaceholder(model, attr, name)"
                      v-model="model[name]"
                      @keyup.enter.prevent="saveRow(model, (rowIndex), false)"
                      @blur="saveAfterChange(model)"
                      tabView="tab2"
                    ></e-time>
                  </div>
                  <div v-else-if="attr.location" :class="'field-'+name">
                    <e-location
                      :name="name"
                      :model="model"
                      :placeholder="getPlaceholder(model, attr, name)"
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :shortMode="attr.location.shortMode"
                      :showMapToggleBtn="attr.location.showMapToggleBtn"
                      @enter="saveRow(model, (rowIndex), false)"
                      @blur="saveAfterChange(model)"
                      @coordinatesChange="saveAfterChange(model)"
                      @locationChange="saveAfterChange(model)"
                      tabView="tab2"
                      :addressData="model.dadata"
                    ></e-location>
                  </div>
                  <div v-else :class="'field-'+name">
                    <input
                      v-bind:disabled="checkBindDisabled(name, model)"
                      :name="name"
                      :placeholder="getPlaceholder(model, attr, name)"
                      v-model="model[name]"
                      @keyup.enter.prevent="saveRow(model, (rowIndex), false)"
                      @blur="saveAfterChange(model)"
                    >
                  </div>
                  <span class="invalid error table-invalid">{{getValidationError(model, name)}}</span>
                </td>
                <td>
                  <div class="buttons is-hide">
                    <template
                      v-if="$scopedSlots['buttons']"
                    >
                      <slot
                        name="buttons"
                        :model="model"
                        :acceptEdit="acceptEdit"
                        :acceptDelete="acceptDelete"
                        :acceptCreate="acceptCreate"
                      ></slot>
                    </template>
                    <template v-else>
                      <button
                        v-if="acceptEdit"
                        @click.prevent="onToggleEditable(model)"
                        class="row-edit"
                        :title="$translate('Редактировать')"
                      ></button>
                      <button
                        v-if="acceptDelete"
                        @click.prevent="deleteRow(model)"
                        class="row-delete"
                        :title="$translate('Удалить')"
                      ></button>
                    </template>
                  </div>
                  <span class="invalid error table-invalid">{{getValidationError(model, 'edit')}}</span>
                </td>
              </tr>
              <tr
                v-else
                @dblclick="onToggleEditable(model, (rowIndex))"
                ref="rows"
                :data-id="model.id || model._storeUUID"
              >
                <td v-for="(attr, name) in attributes">
                  <div v-if="attr.hasOwnProperty('transform')"
                       :class="'field-'+name"
                       v-html="attr.transform(model)"></div>
                  <div v-else
                       v-html="model[name]"
                       :class="'field-'+name"
                  ></div>
                </td>
                <td>
                  <div class="buttons is-hide">
                    <template
                      v-if="$scopedSlots['buttons']"
                    >
                      <slot
                        name="buttons"
                        :model="model"
                        :acceptEdit="acceptEdit"
                        :acceptDelete="acceptDelete"
                        :acceptCreate="acceptCreate"
                      ></slot>
                    </template>
                    <template v-else>
                      <button
                        v-if="acceptEdit"
                        @click.prevent="onToggleEditable(model)"
                        class="row-edit"
                        :title="$translate('Редактировать')"
                      ></button>
                      <button
                        v-if="acceptDelete"
                        @click.prevent="deleteRow(model)"
                        class="row-delete"
                        :title="$translate('Удалить')"
                      ></button>
                    </template>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="showSummaryColumns" class="summary bold">
              <td v-for="(attr, name, index) in attributes">
                <div v-if="index > 0" :class="'field-'+name">
                  {{getSumOf(name)}}
                </div>
                <div v-else>{{$translate('Итого')}}</div>
              </td>
              <td></td>
            </tr>
            </tbody>
            <tbody v-else-if="error">
            <tr>
              <td :colspan="colspan" class="table-error">
                {{error}}
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td :colspan="colspan">
                {{$translate('Нет записей')}}
              </td>
            </tr>
            </tbody>
            <template v-if="fewRows">
              <tr class="empty-row" :style="{'height': emptyRowHeight}">
                <td v-for="(attr, name) in attributes">
                  <div></div>
                </td>
                <td><div></div></td>
              </tr>
            </template>
          </table>
        </div>
      </e-perfect-scrollbar>
    </div>

    <div
      class="e-table-editable-pagination"
      v-if="enablePagination && !tableInOfflineMode"
    >
      <e-pagination
        v-if="meta"
        :auto="false"
        :currentPage="meta.currentPage"
        :pageCount="meta.pageCount"
        :totalCount="meta.totalCount"
        :perPage="meta.perPage"
        @paginate="onPaginate"
      ></e-pagination>
    </div>
  </div>
</template>

<script>
  import {PERMS} from '../../config/permissions.js'
  import tableEditableMixin from './table-editable-mixin.js'
  import tableEditableScrollMixin from './table-editable-scroll-mixin.js'
  /* {
    fieldName: {
       label: 'fieldLabel',
       type: (input)
       required: (true|false)
       minlength: 0,
       maxlength: 0
       disableEdit: (true|false),
       suggestion: {
         see suggestion option
      }
    }
  } */

  export default {
    name: 'e-table-editable',
    mixins: [tableEditableMixin, tableEditableScrollMixin],
    watch: {
      dataUrl: 'fetchData'
    },
    props: {
      tabView: {
        type: String,
        default: 'tabView2'
      },
      enableOnAdd: {
        type: Array,
        default: function () {
          return []
        }
      },
      onlyOneAdd: {
        type: Boolean,
        default: true
      },
      defaultPlaceholder: {
        type: String,
        default: '0.000'
      },
      defaultValidationRulePattern: {
        type: String,
        default: '^(\\d*((\\.\\d{0,2}))?(\\d))$'
      },
      tableClass: {
        type: String,
        default: ''
      },
      /* data: null, */
      dataUrl: {
        type: String,
        default: null
      },
      // return null for disable edit
      patchUrl: {
        type: Function,
        default: function () {
          return null
        }
      },
      postUrl: {
        type: Function,
        default: function () {
          return {}
        }
      },
      deleteUrl: {
        type: Function,
        default: function () {
          return {}
        }
      },
      attributes: {
        type: Object,
        default: function () {
          return {}
        }
      },
      tableInOnlineMode: {
        type: [String, Number, Boolean],
        default: null
      },
      afterFetchData: {
        type: Function,
        default: function (ctx, data) {
          return data
        }
      },
      afterValidate: {
        type: Function,
        // eslint-disable-next-line
        default: function (ctx, model, errors, els) {
          return errors
        }
      },
      summaryColumns: {
        type: Array,
        default: function () {
          return []
        }
      },
      exitFromEditModeAfterSave: {
        type: Boolean,
        default: false
      },
      /***/
      actionColumnWidth: {
        type: Number,
        default: 130
      },
      defaultColumnWidth: {
        type: [Number, String],
        default: 200
      },
      /* enable/desibel js table height calculation */
      calculateTableHeight: {
        type: Boolean,
        default: true
      },
      /* get height */
      headerSelector: {
        type: String,
        default: '.e-form-modal .header'
      },
      /* get height */
      toolbarSelector: {
        type: String,
        default: '.e-form-modal .toolbar-table'
      },
      /* get height */
      footerSelector: {
        type: String,
        default: '.e-form-modal .footer'
      },
      /* height of table bottom scroll */
      tableBottomScrollHeight: {
        type: Number,
        default: 0 // 15
      },
      fixedColumns: {
        type: Array,
        default: function () {
          return []
        }
      },
      /* toolbar+header+footert height */
      foreignElementsHeight: {
        type: [Number, String],
        default: 0 // 340
      },
      tableHeight: {
        type: [Number, String],
        default: 0
      },
      tableHeightRight: {
        type: [Number, String],
        default: 0
      },
      toTopRowsCount: {
        type: Number,
        default: 3
      },
      fewRowsCount: {
        type: Number,
        default: 2
      },
      scrollBarUpdateStreamName: {
        type: String,
        default: null
      },
      scrollBarEmitTypes: {
        type: Array,
        default: function () {
          return ['vue']
        }
      },
      enabledActions: {
        type: Array,
        default: function () {
          return [PERMS.EDIT, PERMS.CREATE, PERMS.DELETE]
        }
      },
      /**
       * call in add and save row
       * use for convert data before send and validate
       */
      prepareRow: {
        type: Function,
        // eslint-disable-next-line
        default: function (model, caller) {
          return model
        }
      },
      enablePagination: {
        type: Boolean,
        default: false
      },
      // TODO: check error catching
      beforeSaveResponse: {
        type: Function,
        // eslint-disable-next-line
        default: function (model, action, offline, ctx) {
          return Promise.resolve(1)
        }
      },
      onToggleEditable: {
        type: Function,
        // eslint-disable-next-line
        default: function (value, rowIndex = -1, skipSaveRow = false) {
          this.toggleEditable(value, rowIndex = -1, skipSaveRow = false)
        }
      },
      autoSaveAfterChange: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
